module.exports = __webpack_public_path__ + "static/media/task-manager-demo.c4f00ad3.mov";